import styled from 'styled-components'

export const ContainerButton = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88.39px;
  padding-top: 1.7em;

  > button {
    font-family: Mulish;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    color: #ffffff;
    mix-blend-mode: normal;
    text-transform: uppercase;
  }
`
export const TitleDescription = styled.p`
  font-family: Mulish;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #858585;
  padding-top: 3px;
  margin-bottom: 0;
`

export const ContainerPaymentWays = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: self-start;
  flex-direction: column;
`

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ContainerTop = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  height: 100%;
`

export const ContainerBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border-left: 1px solid #e6e6e6; */
  padding-left: 2rem;
  padding-left: 1.5rem;
`

export const ColExpand = styled.div`
  flex-grow: 1;
  overflow: auto;
  /* height: 0; */
`
